import { render } from "./ObjectsContainer.vue?vue&type=template&id=e6b55d96"
import script from "./ObjectsContainer.vue?vue&type=script&lang=js"
export * from "./ObjectsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__